export default "__VITE_ASSET__CpV0fQY1__"